import { ReactElement } from 'react';

import { Visit, VisitFinishNotApprovedCommand, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, FullscreenSpinner } from '@dreryk/react-components';

import { visitDetailsTranslationKeys, visitTranslationKeys } from '../../../../translations';
import { useVisitCommand } from '../../../../visit/form/actionBar/shared/confirmVisit.hooks';
import { useVisitPushBack } from '../../../../visit/form/visitForm.hooks';
import { mapVisitToVisitFormBean } from '../../../../visit/form/visitForm.utils';
import { VisitId } from '../../PrescriptionIssuingPanel.types';

type ClosePrescriptionVisitActionChildrenRenderProps = {
   readonly closeVisit: VoidFunction;
};

type ClosePrescriptionVisitActionProps = {
   readonly visitId: VisitId;
   readonly children: (renderProps: ClosePrescriptionVisitActionChildrenRenderProps) => ReactElement;
};

export const ClosePrescriptionVisitAction = (props: ClosePrescriptionVisitActionProps): ReactElement => {
   const pushBack = useVisitPushBack();

   const { data: visit } = useCqrsFind<Visit | null>(() => {
      const query = new VisitQuery();
      query.visitId = props.visitId;
      return query;
   });

   const { executeAsync: executeCloseVisit, loading } = useVisitCommand(VisitFinishNotApprovedCommand, {
      visitId: props.visitId,
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(visitDetailsTranslationKeys.visitSaved);
         pushBack();
      },
   });

   const closeVisit = (): void => {
      if (!visit) {
         return;
      }
      executeCloseVisit(mapVisitToVisitFormBean(visit));
   };

   return (
      <>
         {props.children({ closeVisit: closeVisit })}
         {loading ? <FullscreenSpinner label={visitTranslationKeys.savingVisit} /> : null}
      </>
   );
};
